// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maropost-app .cta-button[data-v-64bbaf7c]:not(.legacy-app *) {
  height: 64px !important;
  padding: 12px !important;
  width: 40px !important;
}
.maropost-app .cta-button--dropdown[data-v-64bbaf7c]:not(.legacy-app *) {
  width: auto !important;
  min-width: 56px !important;
  padding: 12px 8px !important;
}`, "",{"version":3,"sources":["webpack://./src/lib/components/header/TheHeader.vue"],"names":[],"mappings":"AACE;EACE,uBAAA;EACA,wBAAA;EACA,sBAAA;AAAJ;AAGE;EACE,sBAAA;EACA,0BAAA;EACA,4BAAA;AAAJ","sourcesContent":["\n  .cta-button {\n    height: 64px !important;\n    padding: 12px !important;\n    width: 40px !important;\n  }\n\n  .cta-button--dropdown {\n    width: auto !important;\n    min-width: 56px !important;\n    padding: 12px 8px !important;\n  }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
